import { Locales } from 'src/i18n'
import Translatable from '../shared/interfaces/Translatable'
import ContentBlockTranslation from 'src/models/Content/ContentBlockTranslation'
import ContentBlockJson from 'src/models/Content/interfaces/ContentBlockJson'
import { PlaceholderKey } from 'src/models/Content/PlaceholderKey'
import { Style } from 'src/models/Content/Style'

export default class ContentBlock implements Translatable {
  id: number
  placeholderKeys: PlaceholderKey[]
  style: Style
  translations: { [locale: string]: ContentBlockTranslation }

  constructor(
    id: number,
    placeholderKeys: PlaceholderKey[],
    style: Style,
    translations: { [locale: string]: ContentBlockTranslation },
  ) {
    this.id = id
    this.placeholderKeys = placeholderKeys
    this.style = style
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): ContentBlockTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }

  static fromJson(data: ContentBlockJson) {
    return new this(
      data.id,
      data.placeholderKeys,
      data.style,
      data.translations.reduce(
        (previous, current) => ({
          ...previous,
          [current.locale]: ContentBlockTranslation.fromJson(current),
        }),
        {},
      ),
    )
  }

  toJson(): ContentBlockJson {
    return {
      id: this.id,
      placeholderKeys: this.placeholderKeys,
      style: this.style,
      translations: Object.values(this.translations).map((t) => t.toJson()),
    }
  }
}
